export default __webpack_public_path__ + "static/media/Google-Play.bd3f7e39.svg";